import { Loader } from '@myosh/odin-components';
import { useAppSelector } from '../../redux/hooks';
import { selectIsFormLoading } from '../../redux/slices/form-builder-slice';
import React from 'react';

const FormBuilderLoader = () => {
  const isFormLoading = useAppSelector(selectIsFormLoading);

  if (isFormLoading) {
    return (
      <div className="absolute z-[10000] grid h-[calc(100%-5rem)] w-[calc(100%-6rem)] place-content-center bg-[rgba(247,247,247,0.4)]">
        <Loader />
      </div>
    );
  }

  return null;
};
export default React.memo(FormBuilderLoader);
